import moment from 'moment';

const maleNames = ["Juan", "Carlos", "Luis", "José", "Miguel", "Fernando", "Jorge", "Pedro", "Ricardo", "Manuel"];
const femaleNames = ["María", "Ana", "Laura", "Carmen", "Juana", "Marta", "Rosa", "Patricia", "Isabel", "Sofía"];
const lastNames = ["García", "Martínez", "López", "Hernández", "González", "Pérez", "Rodríguez", "Sánchez", "Ramírez", "Cruz"];

const generateRandomValue = (min, max, seed) => {
  const random = Math.sin(seed) * 10000;
  return (random - Math.floor(random)) * (max - min) + min;
};

const generateRandomInt = (min, max, seed) => {
  return Math.floor(generateRandomValue(min, max + 1, seed));
};

const generateMockUser = (id, gender) => {
  const firstNameList = gender === 'male' ? maleNames : femaleNames;
  const firstName = firstNameList[id % firstNameList.length];
  const lastName = lastNames[id % lastNames.length];
  const fullName = `${firstName} ${lastName}`;
  return {
    UsuarioID: id,
    Nombre: fullName,
    StressAvgAVG: generateRandomValue(20, 70, id),
    SleepHoursAVG: generateRandomValue(5, 9, id),
    HRVValueAvgAVG: generateRandomValue(20, 70, id),
    StepsAVG: generateRandomInt(5000, 15000, id),
    StepsSUM: generateRandomInt(35000, 105000, id),
    DistanceAVG: generateRandomValue(3, 10, id),
    DistanceSUM: generateRandomValue(21, 70, id),
    CaloriesAVG: generateRandomValue(150, 300, id),
    CaloriesSUM: generateRandomValue(1050, 2100, id),
    GlucoseAVG: generateRandomValue(70, 140, id + 1000),
    BloodPressureAVG: generateRandomValue(90, 140, id + 2000)
  };
};

const generateMockUsers = (count) => {
  const users = [];
  for (let i = 1; i <= count; i++) {
    const gender = i % 2 === 0 ? 'female' : 'male';
    users.push(generateMockUser(i, gender));
  }
  return users;
};

const areaNames = ["Recursos Humanos", "Finanzas", "Marketing", "Ventas", "TI", "Atención al Cliente", "Operaciones", "Legal", "I+D", "Administración"];
const diseaseNames = ["Hipertensión", "Diabetes Tipo 1", "Diabetes Tipo 2", "Hipercolesterolemia", "Obesidad"];

const generateMockAreas = () => {
  const areas = [];
  for (let i = 0; i < areaNames.length; i++) {
    areas.push({
      AreaId: i + 1,
      Nombre: areaNames[i],
      StressAvgAVG: generateRandomValue(20, 70, i + 1)
    });
  }
  return areas;
};

export const getMockData = (start, end) => {
  return new Promise((resolve) => {
    const days = end.diff(start, 'days') + 1;
    const mockData = [];
    for (let i = 0; i < days; i++) {
      const date = moment(start).add(i, 'days').format('YYYY-MM-DD');
      mockData.push({
        date,
        CaloriesAVG: generateRandomValue(150, 300, i),
        CaloriesSUM: generateRandomValue(1050, 2100, i),
        DistanceAVG: generateRandomValue(3, 10, i),
        DistanceSUM: generateRandomValue(21, 70, i),
        HRVValueAvgAVG: generateRandomValue(20, 70, i),
        SleepHoursAVG: generateRandomValue(5, 9, i),
        SleepHoursAwakeAVG: generateRandomValue(0.5, 1.5, i),
        SleepHoursDeepAVG: generateRandomValue(1, 3, i),
        SleepHoursLightAVG: generateRandomValue(3, 6, i),
        StepsAVG: generateRandomInt(5000, 15000, i),
        StepsSUM: generateRandomInt(35000, 105000, i),
        StressAvgAVG: generateRandomValue(20, 70, i)
      });
    }
    resolve(mockData);
  });
};

export const getMockUsers = (start, end) => {
  return new Promise((resolve) => {
    const days = end.diff(start, 'days') + 1;
    const mockUsers = [];
    for (let i = 0; i < days; i++) {
      mockUsers.push(...generateMockUsers(100));
    }
    resolve(mockUsers);
  });
};

export const getMockDiseases = () => Promise.resolve(
  diseaseNames.map((name) => ({ name }))
);

export const getMockAreas = (start, end) => {
  return new Promise((resolve) => {
    const areas = [];
    for (let i = 0; i < areaNames.length; i++) {
      areas.push({
        AreaId: i + 1,
        Nombre: areaNames[i],
        StressAvgAVG: generateRandomValue(20, 70, i + 1)
      });
    }
    resolve(areas);
  });
};

export const getMockAreaData = (start, end, areaId) => {
  return new Promise((resolve) => {
    const days = end.diff(start, 'days') + 1;
    const mockData = [];
    for (let i = 0; i < days; i++) {
      const date = moment(start).add(i, 'days').format('YYYY-MM-DD');
      mockData.push({
        date,
        CaloriesAVG: generateRandomValue(150, 300, areaId + i),
        CaloriesSUM: generateRandomValue(1050, 2100, areaId + i),
        DistanceAVG: generateRandomValue(3, 10, areaId + i),
        DistanceSUM: generateRandomValue(21, 70, areaId + i),
        HRVValueAvgAVG: generateRandomValue(20, 70, areaId + i),
        SleepHoursAVG: generateRandomValue(5, 9, areaId + i),
        SleepHoursAwakeAVG: generateRandomValue(0.5, 1.5, areaId + i),
        SleepHoursDeepAVG: generateRandomValue(1, 3, areaId + i),
        SleepHoursLightAVG: generateRandomValue(3, 6, areaId + i),
        StepsAVG: generateRandomInt(5000, 15000, areaId + i),
        StepsSUM: generateRandomInt(35000, 105000, areaId + i),
        StressAvgAVG: generateRandomValue(20, 70, areaId + i)
      });
    }
    resolve(mockData);
  });
};

const generateMockUsersForArea = (areaId, count) => {
  const users = [];
  for (let i = 1; i <= count; i++) {
    const gender = i % 2 === 0 ? 'female' : 'male';
    users.push(generateMockUser(areaId * 100 + i, gender));
  }
  return users;
};

export const getMockUserIndividualData = (start, end, userId) => {
  return new Promise((resolve) => {
    const days = end.diff(start, 'days') + 1;
    const mockData = [];
    for (let i = 0; i < days; i++) {
      const date = moment(start).add(i, 'days').format('YYYY-MM-DD');
      mockData.push({
        date,
        CaloriesAVG: generateRandomValue(150, 300, userId + i),
        CaloriesSUM: generateRandomValue(1050, 2100, userId + i),
        DistanceAVG: generateRandomValue(3, 10, userId + i),
        DistanceSUM: generateRandomValue(21, 70, userId + i),
        HRVValueAvgAVG: generateRandomValue(20, 70, userId + i),
        SleepHoursAVG: generateRandomValue(5, 9, userId + i),
        SleepHoursAwakeAVG: generateRandomValue(0.5, 1.5, userId + i),
        SleepHoursDeepAVG: generateRandomValue(1, 3, userId + i),
        SleepHoursLightAVG: generateRandomValue(3, 6, userId + i),
        StepsAVG: generateRandomInt(5000, 15000, userId + i),
        StepsSUM: generateRandomInt(35000, 105000, userId + i),
        StressAvgAVG: generateRandomValue(20, 70, userId + i)
      });
    }
    resolve(mockData);
  });
};

export const getMockUserIndividualSleep = (start, end, userId) => {
  return new Promise((resolve) => {
    const days = end.diff(start, 'days') + 1;
    const mockSleepData = [];
    for (let i = 0; i < days; i++) {
      const date = moment(start).add(i, 'days').format('YYYY-MM-DD');
      mockSleepData.push({
        HistoryDate: date,
        Valor: generateRandomValue(6, 9, userId + i)
      });
    }
    resolve(mockSleepData);
  });
};

export const getMockUserIndividualHeartRate = (start, end, userId) => {
  return new Promise((resolve) => {
    const days = end.diff(start, 'days') + 1;
    const mockHeartRateData = [];
    for (let i = 0; i < days; i++) {
      const date = moment(start).add(i, 'days').format('YYYY-MM-DD');
      mockHeartRateData.push({
        date,
        value: generateRandomValue(60, 100, userId + i)
      });
    }
    resolve(mockHeartRateData);
  });
};

export const getMockPoblationalData = (start, end) => {
  return new Promise((resolve) => {
    resolve([
      {
        total: 200,
        with_data: 130,
        total_men: 80,
        total_women: 50,
        men_age_18_25: 10,
        men_age_26_35: 35,
        men_age_36_45: 20,
        men_age_46_55: 10,
        men_age_55_plus: 5,
        women_age_18_25: 5,
        women_age_26_35: 15,
        women_age_36_45: 20,
        women_age_46_55: 8,
        women_age_55_plus: 2
      }
    ]);
  });
};
